const SessionExpiredModal = ({ open, onGoToLogin }) => {
  if (!open) return null

  return (
    <div
      aria-modal="true"
      className="fixed inset-0 z-[100] flex items-center justify-center bg-gray-600 bg-opacity-50 backdrop-blur-sm"
      role="dialog"
    >
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6 flex flex-col gap-4">
        <h2 className="text-xl font-bold">Session expired</h2>
        <p className="text-base text-gray-700">
          Your session has expired. Please log in again to continue.
        </p>
        <div className="flex justify-end mt-2">
          <button
            autoFocus
            className="bg-secondary hover:bg-secondary_dark text-white px-6 py-2 rounded-lg"
            type="button"
            onClick={onGoToLogin}
          >
            Go to login screen
          </button>
        </div>
      </div>
    </div>
  )
}

export default SessionExpiredModal
